import type { AddressResult } from '@alexanderathoodly/data-models'

interface LocalBusiness {
	'@context': 'https://schema.org'
	'@type': 'LocalBusiness'
	address: {
		'@type': 'PostalAddress'
		addressLocality: string
		addressRegion: string
		streetAddress: string
	}
	description: string
	name: string
	image?: string
	priceRange: string
	additionalType: 'Coworking office'
	url: string
	brand: string
	keywords: string
	tourBookingPage: string
	review?: Review[]
	amenityFeature?: AmenityFeature[]
}

export interface AmenityFeature {
	'@type': 'LocationFeatureSpecification'
	name: string
	value: boolean
}

export interface Review {
	'@type': 'Review'
	reviewBody: string
	author: { '@type': 'Person'; name: string }
}

export function getLocalBusinessObj(
	name: string,
	brand: string,
	description: string,
	address: AddressResult,
	priceRange: string,
	url: string,
	keywords: string,
	image?: string | undefined,
	amenities?: string[],
	reviews?: { review: string; author: string }[]
): LocalBusiness {
	const localBusiness: LocalBusiness = {
		'@context': 'https://schema.org',
		'@type': 'LocalBusiness',
		address: {
			'@type': 'PostalAddress',
			addressLocality: address.locator,
			addressRegion: address.city,
			streetAddress: address.street,
		},
		description,
		name: name,
		priceRange: `Från ${priceRange}kr/person/månad`,
		additionalType: 'Coworking office',
		url: `https://yta.se/kontorshotell/${url}`,
		brand,
		keywords,
		tourBookingPage: `https://yta.se/kontorshotell/${url}`,
	}
	if (image) {
		localBusiness.image = image
	}
	if (reviews) {
		localBusiness.review = reviews.map((r) => {
			return {
				'@type': 'Review',
				reviewBody: r.review,
				author: { '@type': 'Person', name: r.author },
			}
		})
	}
	if (amenities) {
		localBusiness.amenityFeature = amenities.map((a) => {
			return {
				'@type': 'LocationFeatureSpecification',
				name: a,
				value: true,
			}
		})
	}
	return localBusiness
}
